<template>
  <div class="rightTableDiv">
    <a-spin :spinning="tableData.loading">
      <div class="otherParameters">
        <div class="titleDiv">
          <div class="title">
            <span>参数字段选择</span>
          </div>
        </div>
        <div class="btnGroup" v-if="$auth('deviceParameter.addOrEdit')">
          <a-button type="primary" @click="save" :loading="saveLoading" class="saveBtn">保存</a-button>
        </div>
        <a-row>
          <a-col :md="5" :sm="24"><a-input defaultValue="参数名称" :disabled="true" class="inputDiv"/></a-col>
          <a-col :md="2" :sm="24"><a-input defaultValue="是否必填" :disabled="true" class="inputDiv"/></a-col>
          <a-col :md="2" :sm="24"><a-input defaultValue="字段状态" :disabled="true" class="inputDiv"/></a-col>
          <a-col :md="15" :sm="24">
            <!--            <div class="inputDiv ant-input">-->
            <!--              <span>字段类型</span>-->
            <!--              <span style="color: #1791FF"><a-icon type="info-circle" style="color: #1791FF;font-size: 14px;margin: 0 9px"/>选择单选时，用顿号分割每个项电，例如：A、B、C、D</span>-->
            <!--            </div>-->

            <a-col :md="3">
              <div class="inputDiv ant-input">
                <span>字段类型</span>
              </div>
            </a-col>
            <a-col :md="21" class="inputDel">
              <div class="inputDiv ant-input">
<!--                <span style="color: #1791FF"><a-icon type="info-circle" style="color: #1791FF;font-size: 14px;margin: 0 9px"/>选择单选时，用顿号分割每个项电，例如：A、B、C、D</span>-->
                <span>字段类型要求</span>
              </div>
            </a-col>
          </a-col>
        </a-row>
        <other-data
          ref="otherData"
          :list="tableData.otherData"
          :originalList="tableData.originalOtherData"
          :delList="delList"
          :fieldList="fieldList"
          @setForceDelete="setForceDelete"
          @resetFieldDisabled="resetFieldDisabled"
          class="otherList"></other-data>
      </div>
    </a-spin>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import OtherData from '@/views/deviceParameter/modules/otherData'
import { addOrEditDeviceParameter, getDeviceParameterList } from '@/api/deviceParameter'
import { getTableData } from '@/api/fieldManage'
export default {
  name: 'TableData',
  components: {
    OtherData
  },
  computed: {
    ...mapGetters(['typeCode', 'anlkl'])
  },
  data () {
    return {
      searchValue: '',
      // 表格数据
      tableData: {
        basicData: [],
        otherData: [],
        originalOtherData: [],
        loading: false,
        forceDelete: null
      },
      fieldList: [],
      btnLoading: false,
      sortedInfo: null,
      scrollY: 0,
      toLeftWidth: 0,
      advanced: false,
      delList: []
    }
  },
  created () {
    this.getFieldList()
  },
  mounted () {

  },
  watch: {
    typeCode () {
      this.getTableData()
    }
  },
  methods: {
    // 获取表格数据
    getTableData () {
      this.tableData.loading = true
      const data = {
        typeCode: this.typeCode.code,
        paging: false
      }
      this.delList = []
      getDeviceParameterList(data).then(res => {
        if (res.status === 0) {
          this.fieldList.forEach(i => {
            i.disabled = i.status === 2
          })
          if (res.data) {
            res.data.forEach(item => {
              item.requiredState = item.requiredState ? 1 : 0
              const index = this.fieldList.findIndex(item2 => item2.id === item.fieldId)
              this.fieldList[index].disabled = true
              item.id = item.fieldId
            })
            this.tableData.otherData = JSON.parse(JSON.stringify(res.data))
            this.tableData.originalOtherData = JSON.parse(JSON.stringify(res.data))
          }
          this.tableData.loading = false
        } else {
          this.$message.error(res.info.message)
          this.tableData.loading = false
        }
      })
    },
    // 获取字段下拉列表
    getFieldList () {
      const data = {
        paging: false
      }
      getTableData(data).then(res => {
        if (res.status === 0) {
          if (res.data) {
            res.data.forEach(item => {
              item.disabled = item.status === 2
            })
          }
          this.fieldList = res.data
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    },
    // 重置field的disabled
    resetFieldDisabled () {
      this.fieldList.forEach(i => {
        i.disabled = i.status === 2
      })
      this.tableData.otherData.forEach(i => {
        const index = this.fieldList.findIndex(item2 => item2.id === i.fieldId)
        this.fieldList[index].disabled = true
      })
    },
    // 获取是否强制删除
    setForceDelete (bol) {
      this.tableData.forceDelete = bol
    },
    // 保存
    save () {
      this.btnLoading = true
      for (let i = 0; i < this.tableData.otherData.length; i++) {
        const item = this.tableData.otherData[i]
        if (!(item.requiredState !== null && item.status !== null && item.name !== '' && item.valueType !== null)) {
          this.$message.error('请填写完整信息！')
          this.btnLoading = false
          return
        } else {
          if (item.valueType === 2 && item.valueOptions === '') {
            this.$message.error('请填写完整信息！')
            this.btnLoading = false
            return
          }
          item.sort = i + 1
        }
      }
      const data = {
        saveList: this.tableData.otherData.concat(this.delList),
        forceDelete: this.tableData.forceDelete ? this.tableData.forceDelete : false,
        typeCode: this.typeCode.code
      }
      addOrEditDeviceParameter(data).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.btnLoading = false
          this.delList = []
          this.getTableData()
        } else {
          this.$message.error(res.info.message)
          this.delList = []
          this.btnLoading = false
        }
      })
        .catch(err => {
          this.btnLoading = false
        })
    }
  }
}
</script>

<style scoped lang="less">
.rightTableDiv {
  height: 100%;
  overflow: hidden;
}
.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  .title span{
    border-left: 4px solid #08409F;
    padding-left: 8px;
    font-weight: bold;
  }
}
.btnGroup {
  display: flex;
  padding: 11px 0;
  border-top: 1px solid #DDDDDD;
}
.inputDiv {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: bold;
  border-radius: 0 !important;
  span {
    font-weight: bold;
  }
}
/deep/.ant-col-md-5 {
  width: 20% !important;
  margin-bottom: 12px;
}
/deep/.ant-col-md-9 {
  width: 40% !important;
  margin-bottom: 12px;
}
/deep/.ant-spin-nested-loading {
  height: 100%;
  .ant-spin-container {
    height: 100%;
    .otherParameters {
      height: calc(100% - 32px);
      .otherList {
        height: calc(100% - 100px);
        overflow-y: scroll;
        overflow-x: hidden;
        position: relative;
      }
    }
  }
}
</style>
